import React, {useState} from 'react';
import moment from 'moment';
import {useMutation, useQuery} from '@apollo/client';
import {updateCreate} from '../../utils/mutation';
import Query from '../../components/Query';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import {isActive} from '../Client/utils';
import {QUERY_USER} from '../Client/graphql';
import {MUTATION_COMMENT_LIKE, MUTATION_COMMENT_SAVE, QUERY_COMMENT_LIST} from './graphql';
import {MUTATION_BLOCK_SAVE, QUERY_BLOCK_LIST} from '../Block/graphql';

const CommentList = ({forumId, isAuthor, isClosed}) => {
  const {user} = useQuery(QUERY_USER).data;

  const [input, setInput] = useState({});

  const query = useQuery(QUERY_COMMENT_LIST, {variables: {forumId}});

  const [save] = useMutation(MUTATION_COMMENT_SAVE, {
    update: (cache, response) => {
      updateCreate(cache, response, {
        query: QUERY_COMMENT_LIST,
        variables: {forumId},
        getTarget: (target, item) => [...target, item],
      });
    },
    onCompleted: data => {
      if (data.commentSave.obj) {
        setInput({content: ''});
      }
    },
  });

  const [like] = useMutation(MUTATION_COMMENT_LIKE);

  const {blockList} = useQuery(QUERY_BLOCK_LIST, {variables: {forumId}}).data || {blockList: []};

  const [blockSave] = useMutation(MUTATION_BLOCK_SAVE, {
    update: (cache, response) => updateCreate(cache, response, {query: QUERY_BLOCK_LIST, variables: {forumId}}),
  });

  return (
    <div className="CommentList">
      {Query(query) || (
        <div className="list-group list-group-flush border rounded">
          {query.data.commentList.map(item => {
            const block = blockList.find(x => x.client.id === (item.user.client && item.user.client.id));
            return (
              <div className="list-group-item px-3 py-3" key={item.id}>
                <div className="row gx-2">
                  <div className="col-auto">
                    <Avatar user={item.user} size={50} />
                  </div>
                  <div className="col">
                    <div className="row align-items-center gx-2 mb-1">
                      <div className="col-auto fw-bold">{item.user.fullname}</div>
                      <div className="col-auto text-muted font-2">{moment(item.createdAt).format('DD MMM YYYY')}</div>
                    </div>
                    <div style={{whiteSpace: 'pre-wrap'}}>{item.content}</div>
                  </div>
                  {isAuthor && item.user.id !== user.id && (
                    <div className="col-auto align-self-center">
                      {item.user.client && !block && (
                        <button
                          onClick={() => blockSave({variables: {input: {forum: forumId, client: item.user.client.id}}})}
                          className="btn btn-sm p-1 me-2"
                        >
                          <Icon name="ban" color="secondary" size={20} />
                        </button>
                      )}
                      <button onClick={() => like({variables: {input: {id: item.id}}})} className="btn btn-sm p-1">
                        <Icon
                          name={`thumbs-up${item.isLiked ? '-solid' : ''}`}
                          color={item.isLiked ? 'primary' : 'secondary'}
                          size={20}
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {!isClosed && (
        <div className="py-4">
          <textarea
            value={input.content}
            onChange={e => setInput({...input, content: e.target.value})}
            className="form-control"
            placeholder="Напишите коммент"
          />
          <button
            onClick={() => save({variables: {input: {forum: forumId, content: input.content || ''}}})}
            className="btn btn-primary mt-3"
          >
            Отправить
          </button>
        </div>
      )}
    </div>
  );
};

export default CommentList;
